import TermsAndConditions from './TermsAndConditions/TermsAndConditions';

export default TermsAndConditions;
